<div (click)="onClick()"
     *ngIf="this.item.cells[this.fieldDefinition.key].value == null && this.item.cells['IsCustom'].value == true"
     class="particle-data-mapping pointer">
  Please select a tool
  <i class="far fa-chevron-down m-l-5"></i>
</div>
<div (click)="onClick()"
     *ngIf="this.item.cells[this.fieldDefinition.key].value  && this.item.cells['IsCustom'].value == true && this.item.cells['IsCustomTopic'].value == true"
     class="particle-data-mapping pointer">
  {{item.cells[fieldDefinition.key]?.displayText}} <i class="far fa-chevron-down m-l-5"></i>
</div>
<div
  *ngIf="this.item.cells[this.fieldDefinition.key].value  && (this.item.cells['IsCustom'].value != true || this.item.cells['IsCustomTopic'].value == false)">
  {{item.cells[fieldDefinition.key]?.displayText}}
</div>
